import { conversationServiceV2 } from 'config/api';
import { phoneNumberFormatter } from 'utils';
import actionTypes from './actionTypes';

const mapClientExternalAddress = (client) => {
  const { emails = [], phoneNumbers = [] } = client || {};

  const allPhoneNumbers = phoneNumbers.reduce((acc, { number }) => {
    const formattedNumber = phoneNumberFormatter(number, 'plus1');
    acc.push(...[number, formattedNumber]);
    return acc;
  }, []);

  return [...emails, ...allPhoneNumbers];
};

export const setClientForInbox = (client) => ({
  type: actionTypes.SET_CLIENT_FOR_CLIENT_INBOX,
  payload: client,
});

export const getClientInboxDataV2 =
  ({ associateId, pageSize, pageNumber }, filter = {}, shouldFetchChat) =>
  async (dispatch, getState) => {
    const { client } = getState().clientingModule.clientInbox;
    const contactAddress = mapClientExternalAddress(client);

    const { messageType: selectedMessageType, ...statusFilters } = filter;
    const messageType = selectedMessageType?.length ? selectedMessageType : ['sms', 'email'];

    if (shouldFetchChat && client.ucaStanleyProfiles?.length) {
      // Fixes data inconsistency issue.
      const mappedProfiles = client.ucaStanleyProfiles.map((profileId) => profileId.split('|')[1]);
      contactAddress.push(...mappedProfiles);
      if (!selectedMessageType?.length) {
        messageType.push('chat');
      }
    }

    if (contactAddress.length > 0) {
      dispatch({ type: actionTypes.CLIENT_INBOX_LOADING });

      try {
        const { data } = await conversationServiceV2.post('/inbox', {
          associateId,
          pagination: {
            from: pageNumber,
            size: pageSize,
          },
          filter: {
            contactAddress,
            messageType,
            ...statusFilters,
          },
        });
        const adjustedPayload = {
          result_hits: data?.Items,
          totalCount: data?.Count,
        };

        dispatch({ type: actionTypes.CLIENT_INBOX_SUCCESS, payload: adjustedPayload });
      } catch (err) {
        dispatch({ type: actionTypes.CLIENT_INBOX_ERROR, payload: err });
      }
    }
  };

export const resetClientInboxData = () => ({
  type: actionTypes.CLIENT_INBOX_RESET,
});

export const setEmailPreferences = (payload) => ({
  type: actionTypes.SET_EMAIL_PREFERENCES,
  payload,
});

export const setEmailLookData = (payload) => ({
  type: actionTypes.SET_EMAIL_LOOK_DATA,
  payload,
});
